<template>
  <div class="page p-persona">
    <div class="page__head">
      <page-header
        :back-location="localePath({ name: 'viewpoint-persona' })"
        :page-theme="activePageTheme"
        :title="activePersona.name"
      />
    </div>
    <div class="page__main page__main--contain">
      <interstitial-content
        :facets="['as-interstitial']"
        :image="interstitialContent.image"
        :text="interstitialContent.text"
      >
        <template #cta-link>
          <n-link :to="personaWizardLink" class="p-viewpoint__link u-reset">
            <responsive-img v-bind="arrowImg" alt="" />
          </n-link>
        </template>
      </interstitial-content>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PageHeader from '@/components/page-header/page-header'
  import InterstitialContent from '@/components/interstitial-content/interstitial-content'
  import { interstitialContentList } from '@/assets/js/model/interstitial-content'
  import { wizardStepList } from '@/assets/js/model/wizard-steps'
  import { getArrow } from '@/assets/js/util/misc/image'
  import { pageIds } from '@/assets/js/model/page'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    meta: {
      titleKey: 'meta.persona.title',
      pageId: pageIds.PERSONA_WIZARD_INTRO,
    },
    components: { ResponsiveImg, InterstitialContent, PageHeader },
    computed: {
      ...mapGetters('navigation', ['activePersona', 'activePageTheme']),
      arrowImg() {
        return getArrow(this.activePageTheme, 'right', 'intro_link')
      },
      interstitialContent() {
        return interstitialContentList.find(({ personaId, wizardStepId }) => {
          return personaId === this.activePersona.id && wizardStepId == null
        })
      },
      personaWizardLink() {
        const wizardSteps = wizardStepList.filter(
          ({ personaId }) => personaId === this.activePersona.id,
        )

        return this.localePath({
          name: 'persona-persona-step-step',
          params: { ...this.$route.params, step: wizardSteps[0].param },
        })
      },
    },
  }
</script>
